// extracted by mini-css-extract-plugin
module.exports = {"normal":"Card_normal__3d_mP","rotate":"Card_rotate__1mWLk","sliver":"Card_sliver__3uDuY","gold":"Card_gold__VbfRt","vip":"Card_vip__2XhzR","selected":"Card_selected__1lGB8"};